/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_N5Inputs */

const en_sorter_ref_n5 = /** @type {(inputs: Sorter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underscore sorts before letters in both schemes, so this one agrees.`)
};

const ko_sorter_ref_n5 = /** @type {(inputs: Sorter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`밑줄은 두 방식 모두에서 글자보다 앞이므로 이 경우는 일치합니다.`)
};

const ja_sorter_ref_n5 = /** @type {(inputs: Sorter_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アンダースコアはどちらの方式でも文字より前なので、この場合は一致します。`)
};

/**
* | output |
* | --- |
* | "Underscore sorts before letters in both schemes, so this one agrees." |
*
* @param {Sorter_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_n5 = /** @type {((inputs?: Sorter_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_n5(inputs)
	if (locale === "ko") return ko_sorter_ref_n5(inputs)
	return ja_sorter_ref_n5(inputs)
});